import React, { useState } from "react";
import { X, Users, Loader2 } from "lucide-react";
import { showToast } from "../../components/common/notification/Notification";
import { createPartnerTeam } from "./networkApi";

const CreateTeamModal = ({ show, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    total_seats: 5,
    status: "ACTIVE",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!show) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name?.trim()) {
      showToast("Team Name is required", { type: "error" });
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await createPartnerTeam({
        name: formData.name.trim(),
        description: formData.description.trim(),
        total_seats: Number(formData.total_seats) || 5,
        used_seats: 0,
        available_seats: Number(formData.total_seats) || 5,
        status: formData.status,
      });

      if (res?.statusType === "SUCCESS" || res?.status === "SUCCESS" || res?.partnerTeam) {
        showToast("Team created successfully!", { type: "success" });
        onSuccess?.();
        onClose?.();
      } else {
        showToast(res?.text || res?.message || "Failed to create team", { type: "error" });
      }
    } catch (err) {
      console.error("Create team error:", err);
      showToast(err?.response?.data?.text || "An error occurred while creating team", {
        type: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="net-modal-overlay" onClick={onClose}>
      <div className="net-modal" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit} className="net-modal-form">
          <div className="net-modal__header">
            <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "#faf5ff",
                  color: "#9333ea",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Users size={18} />
              </div>
              <div>
                <h3 className="net-modal__title">Create Partner Team</h3>
                <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
                  Organize your agency, associates, and sales staff
                </p>
              </div>
            </div>
            <button type="button" className="net-drawer__close" onClick={onClose}>
              <X size={18} />
            </button>
          </div>

          <div className="net-modal__body">
            <div className="net-form-group">
              <label className="net-form-label">Team Name *</label>
              <input
                type="text"
                name="name"
                className="net-form-input"
                placeholder="e.g. Alpha Sales & Marketing Team"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="net-form-group">
              <label className="net-form-label">Description</label>
              <textarea
                name="description"
                className="net-form-textarea"
                placeholder="Brief summary of team focus or regional coverage..."
                value={formData.description}
                onChange={handleInputChange}
              />
            </div>

            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">Total Allocated Seats</label>
                <input
                  type="number"
                  name="total_seats"
                  className="net-form-input"
                  min={1}
                  max={100}
                  value={formData.total_seats}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Initial Status</label>
                <select
                  name="status"
                  className="net-form-select"
                  value={formData.status}
                  onChange={handleInputChange}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>
            </div>
          </div>

          <div className="net-modal__footer">
            <button type="button" className="net-btn net-btn--secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="net-btn net-btn--primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Loader2 size={16} className="net-spin" /> Creating...
                </>
              ) : (
                "Create Team"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTeamModal;
